import { useCallback, useState } from 'react';

const STORAGE_PREFIX = 'feature_seen_';

export const useFeatureBadge = (key: string) => {
  const storageKey = `${STORAGE_PREFIX}${key}`;

  const [seen, setSeen] = useState<boolean>(() => {
    try {
      return localStorage.getItem(storageKey) === '1';
    } catch {
      return false;
    }
  });

  const markSeen = useCallback(() => {
    if (seen) return;
    try {
      localStorage.setItem(storageKey, '1');
    } catch {
      // localStorage 利用不可の環境では state のみ更新
    }
    setSeen(true);
  }, [storageKey, seen]);

  return { isNew: !seen, markSeen };
};
